import { Box, FormControlLabel, Grid, Paper, Slide, Switch, Typography, useMediaQuery } from "@mui/material";
import { QRCodeSVG } from "qrcode.react";
import React, { useEffect, useRef, useState } from 'react'
import {useNavigate, useParams } from "react-router-dom";
import {io} from "socket.io-client"
import { fetchPollChartsData, socBaseURL } from "../../../backend/backendApis";
import './LiveResult.css'
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import CustomPieChart from "../../CustomComponents/CustomPieChart";
import CustomDropDown from "../../CustomDropDown";
import { pollPieModes } from "../../../utils/constants";
import HttpService from "../../../backend/requestApis";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { ArrowCircleDown, ArrowDownward, Download, KeyboardArrowUp, KeyboardArrowUpOutlined } from "@mui/icons-material";
import { headingBlue, maroon, yellowish } from "../../../assets/colors";
import logoBase64 from "../../../assets/images/WORK_logo.png";
import compLogoBase64 from "../../../assets/images/compassionMonth.png"
import Loader from "../../Loader";


function SlideTransition(props){
    return <Slide {...props} direction="up"
      // timeout={1500}
    />
  }


const LiveResult = () => {

  const navigate = useNavigate()

  const isMobile = useMediaQuery("(max-width:600px)");

  const {id, logo} = useParams()

  const [socketId, setSocketId] = useState('')
  const [queue, setQueue] = useState([])
  const [current, setCurrent] = useState(null);

  useEffect(() => {
    const socket = io(socBaseURL, {
      transports: ["websocket", "polling"]
    })

    socket.on("connect", () => {
      console.log("Connected", socket.id);
      setSocketId(socket.id)
      socket.emit("joinProgram", id)
    });

    socket.on("connect_error", (err) => {
      console.error("Connection failed:", err.message);
    });

    socket.on("pollCount", (data) => {
      console.log("data recieve from socket: ", data)
      setData(data.content)
      setQueue((prev) => [...prev, data.voterName])
    })

    return () => {
      socket.off("pollCount")
    }
  }, [])
  
	// const location = useLocation();
	
  var url = window.location.origin
	url = url + `/castpoll/id/${id}` 

  const qrRef = useRef(null)

  const selectedLogo = (logo === 'WORK' ? logoBase64 : compLogoBase64)

  const [data, setData] = useState([])
  const [mode, setMode] = useState('Percentage')
  const [qrCollapsed, setQRCollapsed] = useState(true)
  const [loading, setLoading] = useState(false)

  const downloadQR = async () => {
    setLoading(true)
    const svg = qrRef.current.querySelector("svg")
    const serializer = new XMLSerializer()
    let svgData = serializer.serializeToString(svg)

    const response = await fetch(selectedLogo)
    const blob = await response.blob()
    const reader = new FileReader()

    reader.onloadend = () => {
      setLoading(true)
      const base64Logo = reader.result

      svgData = svgData.replace(/(xlink:)?href=".*?"/, `href="${base64Logo}"`);

      const canvas = document.createElement("canvas")
      const ctx = canvas.getContext("2d")

      const img = new Image()

      img.onload = () => {
        canvas.width = img.width
        canvas.height = img.height
        ctx.drawImage(img, 0, 0)

        const pngFile = canvas.toDataURL("image/png")

        const downloadLink = document.createElement("a")
        downloadLink.href = pngFile
        downloadLink.download = 'qrCode.png'
        downloadLink.click()
        setLoading(false)
      }

      const svgBase64 = btoa(
        new Uint8Array(new TextEncoder().encode(svgData))
          .reduce((data, byte) => data + String.fromCharCode(byte), "")
      );
      img.src = "data:image/svg+xml;base64," + svgBase64

      setLoading(false)

    }

    reader.readAsDataURL(blob)
    setLoading(false)

  }

  

  useEffect(() => {
    if(!current && queue.length > 0){
      const next = queue[0]
      setCurrent(next);
      setQueue((prev) => prev.slice(1))
    }
  }, [queue, current])

  const handleClose = (event, reason) => {
    if( reason === 'clickaway')
      return 
    setCurrent(null)
  }

  useEffect(() => {
    if( socketId){
      setLoading()
      let options = {
        url: fetchPollChartsData,
        method: 'GET',
        params: {
          programId: id,
          socketId: socketId
        },
        headers: {
          Authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : null
        }
      }
      
      HttpService(options).then((data) => {
        console.log("Fetched the pie chart Data.")
        setLoading(false)
      }).catch(err => {
        console.log('Error in fetching the pie chart data: ', err)
        if( err.status === 403){
          setLoading(false)
          localStorage.clear()
          navigate('/login')
        } else {
          setLoading(false)
        }
        
      })}
  }, [socketId])

  const updateModeChange = (value) => {
    setMode(value)
  }
  
  const updateQRCollapse = () => {
    setQRCollapsed(!qrCollapsed)
  }

  return (
    <>
      <Box className = {isMobile ? 'resultOuterBoxStyleMobile' : 'resultOuterBoxStyle'}>
        {loading && <Loader></Loader>}
        <Box className = 'titleBoxStyle'>
          <Typography style={{fontSize: isMobile? '1rem' : '2rem'}} className = "titleTextStyle">{data?.[0]?.programName && data?.[0]?.programName != '' ? data?.[0]?.programName : 'Live Poll'}</Typography>
        </Box>
        {/* <Typography style={{fontSize: isMobile? '1rem' : '2rem'}} className = "titleTextStyle">{data?.[0]?.programName && data?.[0]?.programName != '' ? data?.[0]?.programName : 'Live Poll'}</Typography> */}
        {isMobile &&
          <Box className='QRTopBar'>
            <FormControlLabel
              control={<Switch checked={qrCollapsed} onChange={() => {
                setQRCollapsed(!qrCollapsed)
              }}/>}
              label={qrCollapsed ? "Result" : "QR Code"}>
            </FormControlLabel>
            {/* <Typography> QR Code</Typography>
            {
              qrCollapsed ?
              <KeyboardArrowDownIcon onClick={() => {setQRCollapsed(!qrCollapsed)}}></KeyboardArrowDownIcon> : 
              <KeyboardArrowUpOutlined onClick={() => {setQRCollapsed(!qrCollapsed)}}></KeyboardArrowUpOutlined>
            } */}
          </Box>
        }

        <Box className= {isMobile ? 'bodyBoxStyleMobile' : 'bodyBoxStyle'}>
          <Box className={isMobile ?'QRBoxMobile' : 'QRBox'} ref={qrRef}>
                {(!isMobile || (isMobile && !qrCollapsed)) &&
                <>
                  <QRCodeSVG value={url} size={isMobile ? 175 : 250}
                    fgColor= {headingBlue}
                    imageSettings={{
                      src: selectedLogo,
                      // height: '0.1rem',
                      height: 40,
                      width: 65,
                      excavate: true
                    }}
                  ></QRCodeSVG>
                  <Typography style={{fontSize: isMobile ? '1rem' : '1.5rem', padding: '0.5rem', color: headingBlue}}> Scan to Vote </Typography>
                  <Box>
                    <Download onClick={() => downloadQR()}></Download>
                  </Box>
                </>  
                }
          </Box>


          { (!isMobile || (isMobile && qrCollapsed)) &&
            <Box className= {isMobile ? 'pieBoxStyleMobile' : 'pieBoxStyle' }>
            <Paper className= {isMobile ? 'piePaperStyleMobile': 'piePaperStyle'}>
            {/* <Paper> */}
              <>
                <Box className='pieDropDownStyle'>
                  <CustomDropDown  
                    list={pollPieModes} 
                    value={mode} 
                    setFunc={updateModeChange}
                    regular={true}
                    width={isMobile ? '8rem' : '10rem'}
                  ></CustomDropDown>
                </Box>
                {data?.length > 0 ? 
                <Grid container spacing={1} className="pieGridStyle">
                  {
                    data?.map((ele) => (
                      <>
                        <Grid item xs={12} sm={6} >
                          <CustomPieChart data={ele} mode={mode}></CustomPieChart>
                          {/* <Typography>{ele.title}</Typography> */}
                        </Grid>
                      </>
                      
                    ))
                  }
                </Grid> :
                <Box>
                  <Typography>No Data </Typography>
                </Box>}
              </>
              

            </Paper>
          </Box>}

          
          {/* <Snackbar
            key={current}
            open={Boolean(current)}
            // TransitionComponent={SlideTransition}
            autoHideDuration={6000}
            onClose={handleClose}
            anchorOrigin={{vertical: "bottom", horizontal: "right"}}
            sx={{
              animation: "floatUp 6s forwards",
            }}

            // message={
            //   <span sx={{
            //     display: "block",
            //     width: "150px",      // fixed width
            //     whiteSpace: "normal", 
            //     wordBreak: "break-word",
            //   }}>
            //     JazakAllah {current}.
            //   </span>
              // }
            
            message={current}
          ></Snackbar>

          <style>
            {`
              @keyframes floatUp{
                  0% { transform: translateY(0); opacity: 1; }
                  80% { transform: translateY(-70vh); opacity: 1; }
                  100% { transform: translateY(-75vh); opacity: 0; }
              }`
            }
          </style> */}
        </Box>
        
      </Box>

    </>
  )
}

export default LiveResult
